var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unavailable-container",class:{ 'with-timer': _vm.timerEnd && !_vm.isExpired }},[(!_vm.timerEnd || _vm.isExpired)?_c('div',[_vm._v("Unavailable")]):_c('div',[_c('div',[_vm._v("Unavailable in")]),_c('div',{staticClass:"remaining-time"},[_vm._v(_vm._s(_vm.remainingTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }